export const PAYMENT_HANDLERS = {
	ADYEN: 'adyen'
};

export const PAYMENT_METHOD_TYPE = {
	CARD: 'card'
};

export const DEFAULT_CURRENCY = 'eur';

export const STATUS = {
	INITIAL: 'initial',
	PROCESSING: 'processing',
	SUCCESS: 'success',
	ERROR: 'error',
	ACTION_REQUIRED: 'action-required'
};
